import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_READY, DataStore, DEFAULT_PATH } from '../utils/utils';
import { ConfigurationService } from '../services/configuration.service';
import { Http, Response, Headers, RequestOptions, RequestMethod, Request } from '@angular/http';
import { AppConfig } from '../boot/app.config';

@Component({
    selector: 'splash',
    template: require('./splash.component.html'),
    styles: [require('./splash.component.css')],
    providers: []
})

export class SplashComponent implements OnInit {
    _baseUrl: string = '';
    title: string = 'Loading...';
    progress: number = 0;
    progressMessage: string = "Loading application...";
    returnUrl: string;

    constructor(private http: Http, private config: AppConfig, private route: ActivatedRoute, private configurationService: ConfigurationService, private router: Router) { };

    ngOnInit() {
        this.returnUrl = this.route.snapshot.params['returnUrl'] || '/';
        //console.log('splash: '+this.returnUrl);

        this._baseUrl = this.config.getConfig('hostName') || '';
        var token = localStorage.getItem('dashboardUser');

        var body = {
            "token": token,
        };
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var options = new RequestOptions({ headers: headers });
        var params = JSON.stringify(body);

        return this.http.post(this._baseUrl + 'getConfigurations', params, options)
            .toPromise()
            .then((response) => this.openURL(response))
            .catch(this.handleError);
    }

    private openURL(response: any) {
        // console.log("I am on url "+this.returnUrl);

        this.configurationService.loadConfiguration().then(() => {
            this.router.navigateByUrl(this.returnUrl);
            return true;
        })
    }

    private handleError = (error: any) => {
        // console.log("I am here"+this.returnUrl);

        localStorage.clear();
        this.router.navigate(['/login;returnUrl=', { returnUrl: this.returnUrl }]);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/splash/splash.component.ts